import script from "./DataCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataCard.vue?vue&type=script&setup=true&lang=ts"

import "./DataCard.vue?vue&type=style&index=0&id=5c5c1938&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c5c1938"]])

export default __exports__